// @flow

import * as React from "react";

import { type ImageType } from "../../types";

import Image from "../atoms/Image";
import LinkHandler from "../atoms/LinkHandler";

import { ReactComponent as Diamond } from "../../../assets/images/shape-diamond.svg";
import { ReactComponent as Ring } from "../../../assets/images/shape-ring-thick-fill.svg";
import { ReactComponent as ActivateLogo } from "../../../assets/images/activate-logo.svg";
import { ReactComponent as ActivateLogoCampaign } from "../../../assets/images/activate-logo-campaign.svg";

type PropsType = {
    heading: string,
    image_desktop?: ImageType,
    image_mobile?: ImageType,
    partner_logo?: ImageType,
    partner_link?: ImageType,
    show_activate_uts_logo?: boolean,
};

const Herocampaign = (props: PropsType): React.Node => {
    const baseClassName = "hero-campaign";
    const classes = [baseClassName];

    return (
        <div className={classes.join(" ")}>
            <div className="hero-campaign__overlay">
                <Image
                    image={props.image_mobile}
                    size={"1536x1536"}
                    alt={props.heading}
                    aspectRatio="375:520"
                    className={"hero-campaign__overlay__mobile"}
                />
                <Image
                    image={props.image_desktop}
                    size={"2048x2048"}
                    alt={props.heading}
                    aspectRatio="1680:890"
                    className={"hero-campaign__overlay__desktop"}
                />
            </div>
            <div className="hero-campaign__logos">
                <>
                    {props.show_activate_uts_logo && (
                        <div className="hero-campaign__logo">
                            <LinkHandler to="/">
                                {/* <ActivateLogo className="primary-nav__logo__svg" />*/}
                                {/* above svg creates issue in safari */}
                                <ActivateLogoCampaign className="primary-nav__logo__svg" />
                            </LinkHandler>
                        </div>
                    )}
                    {props.partner_logo && (
                        <div
                            className="hero-campaign__partner-logo"
                            style={{
                                height: props.partner_logo.height / 2 + "px",
                            }}
                        >
                            <LinkHandler
                                to={props.partner_link}
                                className="hero-campaign__partner-logo__link"
                                target="_blank"
                            >
                                <img
                                    alt={props.partner_logo.alt}
                                    src={props.partner_logo.url}
                                    height={props.partner_logo.height / 2}
                                />
                                {/* <Image
                                    alt={props.partner_logo.alt}
                                    image={props.partner_logo}
                                    size={"medium"}
                                /> */}
                            </LinkHandler>
                        </div>
                    )}
                </>
            </div>
            <Diamond className="hero-campaign__diamond" />
            <Ring className="hero-campaign__ring" />
            <h1 className="hero-campaign__heading">{props.heading}</h1>
        </div>
    );
};

export default Herocampaign;
